import { Datepicker, MbscCalendarEvent } from "@mobiscroll/react";
import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import { createPatientApi } from "../../../../api-helpers/PatientApiHelper";
import { ToastConfig } from "../../../../components/Toaster";
import { AddInsurance, Insurance, PatientPersonalInfo } from "patients-experience-client";
import { LookupDropdown } from "../../../../components/DropDown/LookupDropdown";
import Lookups from "../../../../constants/Lookups";
import Spinner from "../../../../components/Spinner";

interface InsuranceProps {
    selectedInsurance: Insurance | undefined;
    setOffCanvasShow: (show: boolean) => void;
    onSubmit: (toasterConfig: ToastConfig) => void;
    patientInfo: PatientPersonalInfo | undefined;
}

export const AddUpdateInsurance: React.FC<InsuranceProps> = (props: InsuranceProps) => {
    const patientApi = createPatientApi();
    const [validated, setValidated] = useState(false);
    const [loading, setLoading] = useState<boolean>(false);
    const handleDiscard = () => {
        props.setOffCanvasShow(false);
    };
    const [addForm, setAddForm] = useState<AddInsurance>({} as AddInsurance);
    const [updateForm, setUpdateForm] = useState<AddInsurance>({
        policyHolderName: props.selectedInsurance?.policyHolderName || '',
        relation: props.selectedInsurance?.relation || '',
        policyHolderDOB: props.selectedInsurance?.policyHolderDOB || new Date(),
        insuranceId: props.selectedInsurance?.insuranceId || '',
        groupNumber: props.selectedInsurance?.groupNumber || '',
        payerName: props.selectedInsurance?.insuranceProvider || '',
        insuranceTypeId: props.selectedInsurance?.insuranceType.id || '',
        startDate: props.selectedInsurance?.startDate || new Date(),
        endDate: props.selectedInsurance?.endDate || new Date(),
        insurancePreference: props.selectedInsurance?.insurancePreference || ''
    });
    const [error, setError] = useState({
        policyHolderDOB: false,
        startDate: false,
        endDate: false,
    });

    useEffect(() => {
        if (error.policyHolderDOB) {
            const label = document.querySelector('label[for="policyHolderDOB"]');
            if (label) {
                const input = label.nextElementSibling?.querySelector('input.mbsc-textfield');
                if (input) {
                    input.classList.add('invalid-input');
                }
            }
        }
        if (error.startDate) {
            const label = document.querySelector('label[for="startDate"]');
            if (label) {
                const input = label.nextElementSibling?.querySelector('input.mbsc-textfield');
                if (input) {
                    input.classList.add('invalid-input');
                }
            }
        }
        if (error.endDate) {
            const label = document.querySelector('label[for="endDate"]');
            if (label) {
                const input = label.nextElementSibling?.querySelector('input.mbsc-textfield');
                if (input) {
                    input.classList.add('invalid-input');
                }
            }
        }
    }, [error]);

    const dateChangeHandlar = (name: string, event: MbscCalendarEvent) => {
        if (props.selectedInsurance) {
            setUpdateForm({
                ...updateForm,
                [name]: event.value
            });
        } else {
            setAddForm({
                ...addForm,
                [name]: event.value
            });
        }
        if (event.value) {
            setError({
                ...error,
                [name]: false
            });
        }
    };

    const formChnageHandler = (event: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>) => {
        const {name, value} = event.target;
        if(props.selectedInsurance) {
          setUpdateForm({
            ...updateForm,
            [name]: value
          });
        } else {
          setAddForm({
            ...addForm,
            [name]: value
          });
        }
      }

      const onTypeUpdate = (type: string) => {
        if(props.selectedInsurance) {
          setUpdateForm({
            ...updateForm,
            insuranceTypeId: type
          });
        } else {
          setAddForm({
            ...addForm,
            insuranceTypeId: type
          });
        }
      }

    const submitHandler = async (event: any) => {
        event.preventDefault();
        setValidated(true);
        setError({
            ...error,
            policyHolderDOB: props.selectedInsurance ? !updateForm.policyHolderDOB : !addForm.policyHolderDOB,
            startDate: props.selectedInsurance ? !updateForm.startDate : !addForm.startDate,
            endDate: props.selectedInsurance ? !updateForm.endDate : !addForm.endDate
          });
        const form = event.currentTarget;
        if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }
        if (error.policyHolderDOB || error.startDate || error.endDate) {
            return;
        }
        setLoading(true);
        try {
            if (props.selectedInsurance) {
                await patientApi.patientsControllerUpdateInsurance(updateForm, props.selectedInsurance!.id, props.patientInfo?.patientId ?? '');
            } else {
                await patientApi.patientsControllerAddInsurance(addForm, props.patientInfo?.patientId ?? '');
            }
            const toasterConfig = {
                type: "success",
                title: props.selectedInsurance ? "Insurance updated successfully!" : "Insurance added successfully!",
                icon: "check_circle_outline",
            };
            props.onSubmit(toasterConfig as ToastConfig);
            setTimeout(() => {
                handleDiscard();
            }, 1000);
        } catch (error: any) {
            const toasterConfig = {
                type: "danger",
                title: error.response.data.message.message.message,
                icon: "error_outline",
            };
            props.onSubmit(toasterConfig as ToastConfig);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
        {loading && <Spinner />}
        <Form
            noValidate
            validated={validated}
            onSubmit={submitHandler}
            className="d-flex flex-column h-100">
            <div className="flex-fill">
                <div className="row g-2 mb-3">
                    <div className="col-12">
                        <div className="mb-3">
                            <label
                                className="form-label fs-12 fw-semibold mb-1"
                            >
                                Policy Holder
                            </label>
                            <input placeholder="Policy Holder" required onChange={formChnageHandler} name="policyHolderName" type="text" className="form-control" value={ props.selectedInsurance ? updateForm.policyHolderName : addForm.policyHolderName } />
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="mb-3">
                            <label
                                className="form-label fs-12 fw-semibold mb-1"
                            >
                                Relation
                            </label>
                            <select required name="relation" value={ props.selectedInsurance ? updateForm.relation : addForm.relation } onChange={formChnageHandler}
                                className="form-select lh-1"
                            >
                                <option value="">Select Relation</option>
                                <option value="Self">Self</option>
                                <option value="Son">Son</option>
                                <option value="Sposue">Sposue</option>
                            </select>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="mb-3">
                            <label
                                htmlFor="policyHolderDOB"
                                className="form-label fs-12 fw-semibold mb-1"
                            >
                                Policy holder's DOB
                            </label>
                            <div className="position-relative">
                                <Datepicker
                                    value={props.selectedInsurance ? updateForm.policyHolderDOB : addForm.policyHolderDOB}
                                    required
                                    name="policyHolderDOB"
                                    controls={["calendar"]}
                                    calendarType="month"
                                    theme="windows"
                                    themeVariant="light"
                                    onChange={(e) => dateChangeHandlar('policyHolderDOB', e)}
                                    placeholder="Select a date"
                                    display="bubble" // Can be 'inline', 'center', 'bubble', etc.
                                    touchUi={true}   // Enables touch-friendly UI
                                    buttons={[]}     // Disables the Set and Cancel buttons
                                    max={new Date()}
                                    cssClass={error.policyHolderDOB ? 'invalid-input' : ''}
                                />
                                <span className="material-symbols-outlined fs-18 calendar-icon">
                                    calendar_month
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="mb-3">
                            <label
                                className="form-label fs-12 fw-semibold mb-1"
                            >
                                Insurance ID
                            </label>
                            <input placeholder="Insurance ID" required onChange={formChnageHandler} name="insuranceId" type="text" className="form-control form-control-sm" value={ props.selectedInsurance ? updateForm.insuranceId : addForm.insuranceId } />
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="mb-3">
                            <label
                                className="form-label fs-12 fw-semibold mb-1"
                            >
                                Group Number
                            </label>
                            <input placeholder="Group Number" onChange={formChnageHandler} name="groupNumber" type="text" className="form-control form-control-sm" value={ props.selectedInsurance ? updateForm.groupNumber : addForm.groupNumber } />
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="mb-3">
                            <label
                                className="form-label fs-12 fw-semibold mb-1"
                            >
                                Insurance Provider
                            </label>
                            <input placeholder="Insurance Provider" required onChange={formChnageHandler} name="payerName" type="text" className="form-control form-control-sm" value={ props.selectedInsurance ? updateForm.payerName : addForm.payerName } />
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="mb-3 ">
                            <label
                                className="form-label fs-12 fw-semibold mb-1"
                            >
                                Type
                            </label>
                            <div className="pt-0">
                                <LookupDropdown 
                                    label="Type"
                                    initialValue={props.selectedInsurance ? updateForm.insuranceTypeId : addForm.insuranceTypeId}
                                    type={Lookups.INSURANCE_TYPE}
                                    onChange={(type) => onTypeUpdate(type?.id ?? '')}
                                    required={true}
                                    disabled={false}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="mb-3">
                            <label
                                htmlFor="startDate"
                                className="form-label fs-12 fw-semibold mb-1"
                            >
                                Start Date
                            </label>
                            <div className="position-relative">
                                <Datepicker
                                    value={props.selectedInsurance ? updateForm.startDate : addForm.startDate}
                                    name="startDate"
                                    controls={["calendar"]}
                                    calendarType="month"
                                    theme="windows"
                                    themeVariant="light"
                                    onChange={(e) => dateChangeHandlar('startDate', e)}
                                    placeholder="Select a date"
                                    display="bubble" // Can be 'inline', 'center', 'bubble', etc.
                                    touchUi={true}   // Enables touch-friendly UI
                                    buttons={[]}     // Disables the Set and Cancel buttons
                                    max={props.selectedInsurance ? updateForm.endDate : addForm.endDate}
                                    cssClass={error.startDate ? 'invalid-input' : ''}
                                    required
                                />
                                <span className="material-symbols-outlined fs-18 calendar-icon">
                                    calendar_month
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="mb-3">
                            <label
                                htmlFor="endDate"
                                className="form-label fs-12 fw-semibold mb-1"
                            >
                                End Date
                            </label>
                            <div className="position-relative">
                                <Datepicker
                                    value={props.selectedInsurance ? updateForm.endDate : addForm.endDate}
                                    name="endDate"
                                    controls={["calendar"]}
                                    calendarType="month"
                                    theme="windows"
                                    themeVariant="light"
                                    onChange={(e) => dateChangeHandlar('endDate', e)}
                                    placeholder="Select a date"
                                    display="bubble" // Can be 'inline', 'center', 'bubble', etc.
                                    touchUi={true}   // Enables touch-friendly UI
                                    buttons={[]}     // Disables the Set and Cancel buttons
                                    min={props.selectedInsurance ? updateForm.startDate : addForm.startDate}
                                    cssClass={error.endDate ? 'invalid-input' : ''}
                                    required
                                />
                                <span className="material-symbols-outlined fs-18 calendar-icon">
                                    calendar_month
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="mb-3">
                            <label
                                className="form-label fs-12 fw-semibold mb-1"
                            >
                                Insurance Preference
                            </label>
                            <select required name="insurancePreference" value={ props.selectedInsurance ? updateForm.insurancePreference : addForm.insurancePreference } onChange={formChnageHandler}
                                className="form-select"
                            >
                                <option value="">Select Insurance Preference</option>
                                <option value="P">Primary</option>
                                <option value="S">Secondary</option>
                                <option value="O">Other</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>

            <div className="offcanvas-footer text-end w-100 border-top d-flex justify-content-between border-top">
                <div>
                    <button
                        className="btn btn-outline-secondary rounded-pill px-5 fs-13"
                        type="reset"
                        onClick={handleDiscard}
                    >
                        Discard
                    </button>
                </div>
                <div>
                    <button
                        className="btn btn-secondary rounded-pill ps-4 pe-5 fs-13"
                        type="submit"
                    >
                        {props.selectedInsurance ? 'Update' : (<>
                            Add</>
                        )}
                    </button>
                </div>
            </div>
        </Form>
        </>
    );
};
